import {useRef} from "react";
import {MultiSelect} from "@mantine/core";
import {useTranslation} from "react-i18next";
import type {LabelGroup} from "../types";
import styles from "./checklist.module.css";

type ShowFilterProps = {
    group: LabelGroup;
    selected: string[];
    onToggle: (labelId: string) => void;
};

export const ShowFilter = ({group, selected, onToggle}: ShowFilterProps) => {
    const {t} = useTranslation();
    const prevRef = useRef<string[]>([]);
    prevRef.current = selected;

    const data = group.labels.map((l) => ({value: l.id, label: l.name}));

    const handleChange = (newValue: string[]) => {
        const prev = new Set(prevRef.current);
        const next = new Set(newValue);

        for (const v of next) {
            if (!prev.has(v)) {
                onToggle(v);
                return;
            }
        }
        for (const v of prev) {
            if (!next.has(v)) {
                onToggle(v);
                return;
            }
        }
    };

    return (
        <MultiSelect
            data={data}
            value={selected}
            onChange={handleChange}
            placeholder={selected.length === 0 ? group.name : undefined}
            aria-label={group.name}
            hidePickedOptions
            nothingFoundMessage={t("Info.ListIsEmpty", {
                defaultValue: "The list is empty",
            })}
            size="sm"
            classNames={{input: styles.filterInput}}
            style={{minWidth: "10rem", maxWidth: "16rem"}}
        />
    );
};
